import './CustomEmailExecutor.scss';
import React from 'react';
import MessageDialog, { IMessageDialogProps } from '@srm/ui/message-dialog';
import { DocumentExecutionService } from '@services/actions/DocumentExecutionService';
import { useActionSubmit } from '@organisms/actions/useActionSubmit';
import { ICustomEmailExecutorProps } from './ICustomEmailExecutorProps';

export const CustomEmailExecutorModal: React.FC<ICustomEmailExecutorProps> = (props: ICustomEmailExecutorProps) => {
    const { errorText, isBusy, okClick, cancelClick } = useActionSubmit({
        completeHandler: props.completeHandler,
        submit: () => new DocumentExecutionService(props.docId).sendCustomEmails(props.actionKey),
    });

    const messageBoxProp: IMessageDialogProps = {
        header: props.title,
        message: props.message,
        showOkButton: true,
        showCancelButton: true,
        okButtonText: props.okButtonText,
        cancelButtonText: props.cancelButtonText,
        size: props.modalSize,
        onConfirm: okClick,
        onCancel: cancelClick,
    };

    return <MessageDialog {...messageBoxProp} errorText={errorText} loading={isBusy} />;
};
